import CustomChip from '@app/components/atoms/CustomChip/CustomChip'
import ModalUpdateStatusCampaign from '@app/components/ModalUpdateStatusCampaign'
import { CAMPAIGN_STATUS } from '@app/constant/CampaignConstant'
import useRemember from '@app/libs/useRemember'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-react'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import { green, red } from '@mui/material/colors'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Section from '../../../../components/atoms/Section/Section'
import CardWidget from '../../../../components/CardWidget'
import ImageSlider from '../../../../components/ImageSlider'
import MenuItem from '../../../../components/MenuItem'
import OptionMenu from '../../../../components/OptionMenu'
import { formatPrice, toDateTime, toRemainingTime } from '../../../../libs/format'

const IconButtonCustom = styled(IconButton)(({ theme, open }) =>
  open
    ? {
        transform: 'rotate(180deg)',
      }
    : {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      }
)

export default function CampaignRequestedDetail() {
  const {
    props: { requestedCampaign },
  } = usePage()
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState(null)
  const [open, setOpen] = useState(false)
  const [openModalConfirm, setOpenModalConfirm] = useState(false)
  const [modalName, setModalName] = useState('')

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleCloseModal = () => setOpenModalConfirm(false)

  const [expandedDescription, setExpandedDescription] = useRemember(
    `campaign-description:${requestedCampaign.id}`,
    true
  )

  const handleExpandClickDescription = () => {
    setExpandedDescription(!expandedDescription)
    setOpen(!open)
  }

  const renderModal = (modalName) => {
    switch (modalName) {
      case 'Approve':
        return (
          <ModalUpdateStatusCampaign
            content={t('MODAL.APPROVE_CONTENT')}
            handleCloseModal={handleCloseModal}
            handleSubmit={() => {
              Inertia.get(
                route('admin.campaigns.status.change', {
                  campaign: requestedCampaign.id,
                  status: CAMPAIGN_STATUS.ACTIVE,
                })
              )
            }}
            openModalConfirm={openModalConfirm}
            status="inactive"
            title={t('MODAL.APPROVE')}
          />
        )
      case 'Active':
        return (
          <ModalUpdateStatusCampaign
            content={t('MODAL.ACTIVE_CONTENT')}
            handleCloseModal={handleCloseModal}
            handleSubmit={() =>
              Inertia.get(
                route('admin.campaigns.status.change', {
                  campaign: requestedCampaign.id,
                  status: CAMPAIGN_STATUS.ACTIVE,
                })
              )
            }
            openModalConfirm={openModalConfirm}
            title={t('MODAL.ACTIVE')}
          />
        )
      case 'Reject':
        return (
          <ModalUpdateStatusCampaign
            content={t('MODAL.REJECT_CONTENT')}
            handleCloseModal={handleCloseModal}
            handleSubmit={() => {
              Inertia.get(
                route('admin.campaigns.status.change', {
                  campaign: requestedCampaign.id,
                  status: CAMPAIGN_STATUS.REJECTED,
                })
              )
            }}
            openModalConfirm={openModalConfirm}
            status="rejected"
            title={t('MODAL.REJECT')}
          />
        )
      default:
        return null
    }
  }

  const checkCondition = () =>
    requestedCampaign.status !== CAMPAIGN_STATUS.IN_ACTIVE && requestedCampaign.status !== CAMPAIGN_STATUS.REJECTED

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item md={4} sm={12} xs={12}>
              <ImageSlider images={requestedCampaign.images} />
            </Grid>
            <Grid item md={8} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={11}>
                  <Typography variant="h4">{requestedCampaign.name}</Typography>
                </Grid>

                <Grid item style={{ display: 'flex', justifyContent: 'flex-end' }} xs={1}>
                  {checkCondition() && (
                    <OptionMenu
                      anchorEl={anchorEl}
                      handleClick={handleClick}
                      handleClose={handleClose}
                      open={null !== anchorEl}
                    >
                      <MenuItem
                        icon={CheckIcon}
                        iconColor={green[600]}
                        name={t('BUTTON.APPROVE')}
                        onClick={() => {
                          handleClose()
                          setModalName('Approve')
                          setOpenModalConfirm(true)
                        }}
                      />
                      <MenuItem
                        icon={CloseIcon}
                        iconColor={red[600]}
                        name={t('BUTTON.REJECT')}
                        onClick={() => {
                          handleClose()
                          setModalName('Reject')
                          setOpenModalConfirm(true)
                        }}
                      />
                    </OptionMenu>
                  )}
                </Grid>
                {renderModal(modalName)}

                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.PARTNER_NAME')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {requestedCampaign.partner.name ? (
                    <Typography variant="body1">{requestedCampaign.partner.name}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.ESTIMATE_COST')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body1">{formatPrice(requestedCampaign.total_estimate_cost)}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.VISIBLE_FROM')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {requestedCampaign.visible_from ? (
                    <Typography variant="body1">{toDateTime(requestedCampaign.visible_from)}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.VISIBLE_TO')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {requestedCampaign.visible_to ? (
                    <Typography variant="body1">{toDateTime(requestedCampaign.visible_to)}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.START_TIME')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {requestedCampaign.start_at ? (
                    <Typography variant="body1">{toDateTime(requestedCampaign.start_at)}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.END_TIME')}
                  </Typography>
                </Grid>

                <Grid item xs={8}>
                  {requestedCampaign.end_at ? (
                    <Typography variant="body1">{toDateTime(requestedCampaign.end_at)}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.REMAIN_TIME')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {requestedCampaign.end_at ? (
                    toRemainingTime(requestedCampaign.start_at, requestedCampaign.end_at)
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.LIMIT_CODE_PER_USER')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {requestedCampaign.codes_per_day ? (
                    <Typography variant="body1">{requestedCampaign.codes_per_day}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.TIME_BETWEEN_REDEEM_CODE')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {requestedCampaign.time_between_redeem ? (
                    <Typography variant="body1">{requestedCampaign.time_between_redeem}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.LINE_OF_CREDIT')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body1">{formatPrice(requestedCampaign.line_of_credit)}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.STATUS')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomChip
                    color={requestedCampaign.status}
                    label={t(`CAMPAIGNS.${requestedCampaign.status.toUpperCase()}`)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={4} md={6} sm={12} xs={12}>
            <CardWidget
              color="warning"
              primary={requestedCampaign.vouchers_count}
              title={t('CAMPAIGN.TOTAL_VOUCHERS')}
            ></CardWidget>
          </Grid>

          <Grid item lg={4} md={6} sm={12} xs={12}>
            <CardWidget
              color="success"
              primary={requestedCampaign.prepaid_vouchers_count}
              title={t('CAMPAIGN.TOTAL_PREPAID_VOUCHERS')}
            ></CardWidget>
          </Grid>
          <Grid item lg={4} md={6} sm={12} xs={12}>
            <CardWidget
              color="danger"
              primary={requestedCampaign.postpaid_vouchers_count}
              title={t('CAMPAIGN.TOTAL_POSTPAID_VOUCHERS')}
            ></CardWidget>
          </Grid>

          <Grid item lg={4} md={6} sm={12} xs={12}>
            <CardWidget
              color="info"
              primary={requestedCampaign.total_get_codes}
              title={t('CAMPAIGNS.TOTAL_GET_CODES')}
            ></CardWidget>
          </Grid>

          <Grid item lg={4} md={6} sm={12} xs={12}>
            <CardWidget
              color="info"
              primary={requestedCampaign.total_estimate_cost}
              title={t('CAMPAIGN.TOTAL_ESTIMATE_PRICES')}
            ></CardWidget>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('CAMPAIGN.DESCRIPTION')}{' '}
                <IconButtonCustom
                  aria-expanded={expandedDescription}
                  aria-label="show more"
                  open={open}
                  onClick={handleExpandClickDescription}
                >
                  <ExpandMoreIcon />
                </IconButtonCustom>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Collapse unmountOnExit in={expandedDescription} timeout="auto">
                {requestedCampaign.description ? (
                  <Typography
                    dangerouslySetInnerHTML={{ __html: requestedCampaign.description }}
                    style={{ wordBreak: 'break-word' }}
                    variant="body1"
                  ></Typography>
                ) : (
                  <Typography variant="body1">{t('DATA.NO_DATA')}</Typography>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>
    </Grid>
  )
}
